import { format } from 'date-fns';

import { DEFAULT_DATE_FORMAT } from 'constants/index';

export const formattedDate = (
  date: Date,
  formatString = DEFAULT_DATE_FORMAT,
  locale?: Locale,
): string => format(date, formatString, { locale });

export const formatCreatedAt = (dateString: string): string =>
  format(new Date(dateString), 'yyyy.MM.dd HH:mm');
